import React from 'react';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Link from 'components/shared/Link';

const useStyles = makeStyles((theme) => ({
  root: {},
  listItem: {
    fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(1, 2),
    borderLeft: `0.25rem solid ${theme.palette.grey[100]}`,
    marginBottom: 0,
    transition: 'border 0.15s ease-in-out',
    [theme.breakpoints.down('md')]: {
      display: 'inline-flex',
      width: '33.3%',
      borderLeft: 'none',
      borderBottom: `0.25rem solid ${theme.palette.grey[100]}`,
      justifyContent: 'center',
      padding: theme.spacing(2, 1),
    },
  },
  selectedItem: {
    "&[class*='Mui-selected']": {
      borderColor: theme.palette.primary.main,
      backgroundColor: 'transparent',
      fontWeight: 600,
    },
  },
}));

const Tabs = ({ items }) => {
  const classes = useStyles();

  return (
    <>
      <List dense={false} component="nav">
        {
          items?.map((item) => (
            <ListItem
              key={`${item.text}`}
              button
              component={Link}
              href={item.href}
              className={classes.listItem}
              selected={item.selected}
              classes={{
                selected: classes.selectedItem,
              }}
            >
              {item.text}
            </ListItem>
          ))
      }
      </List>
    </>
  );
};

export default Tabs;
